import React, { useCallback } from 'react'

import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import { useMetadataToTrackedEvent } from 'common/metadata-custom-hooks'
import { DOMAIN_TYPES, EVENT_TYPES } from 'common/track-event-constants'
import trackEvents from 'common/track-events'
import FwdRefNavLink from 'components/FwdRefNavLink'

const useStyles = makeStyles((theme) => {
  return {
    button: {
      background: 'rgba(33, 150, 243, 0.08)',
      color: theme.palette.info.dark,
      borderRadius: '21px',
      '&:hover': {
        background: `rgba(33, 150, 243, 0.20)`,
      },
    },
  }
})

export const useClickTracking = (label) => {
  const DomainType = DOMAIN_TYPES.STUDENT_DASHBOARD
  const getFn = useMetadataToTrackedEvent(EVENT_TYPES.PREDEFINED_SEARCH)
  const cb = useCallback(() => {
    const te = getFn()
    trackEvents({
      ...te,
      DomainType,
      EventData: {
        ...te.EventData,
        SearchFilter: label,
      },
    })
  }, [label, getFn])
  return cb
}

export const SearchButton = ({ label, eventDataLabel, to, condensed, startIcon, onSelect }) => {
  const classes = useStyles()
  const trackClickFn = useClickTracking(eventDataLabel || label)

  const onClick = useCallback(() => {
    trackClickFn()
    onSelect && onSelect()
  }, [onSelect, trackClickFn])

  return (
    <Button
      startIcon={startIcon}
      aria-label={label}
      className={classes.button}
      variant="contained"
      component={FwdRefNavLink}
      to={to}
      onClick={onClick}
      disableElevation
      size={condensed ? 'small' : 'large'}
    >
      {label}
    </Button>
  )
}

SearchButton.propTypes = {
  label: PropTypes.string,
  to: PropTypes.string,
  condensed: PropTypes.bool,
  startIcon: PropTypes.node,
  onSelect: PropTypes.func,
}

export default SearchButton
